// src/components/trending/TrendingClaimCard.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import for navigation
import '../../styles/trending/ClaimCard.css';

const TrendingClaimCard = ({ claim }) => {
  const [showRelatedBills, setShowRelatedBills] = useState(false);
  const navigate = useNavigate(); // Hook for navigation
  
  const verdictColorMap = {
    'Valid': '#54971d',
    'Mostly True': '#42a34a',
    'Ambiguous': '#f1b434',
    'Misleading': '#e57e30',
    'False': '#bc3d38',
    'Invalid': '#ff4757'
  };

  const verdictColor = verdictColorMap[claim.verdict] || '#f1b434';
  const topicColor = getTopicColor(claim.policy_area);
  
  // Toggle function for related bills visibility
  const toggleRelatedBills = () => {
    setShowRelatedBills(!showRelatedBills);
  };
  
  // Function to handle redirection to claim result page
  const handleViewDetails = () => {
    navigate(`/ask/${claim.search_id}`);
  };
  
  return (
    <div className="claim-card">
      <div className="claim-header" style={{ backgroundColor: topicColor }}>
        <h3>{claim.policy_area} - {claim.topic_name}</h3>
      </div>
      <div className="claim-content">
        <p className="claim-statement">"{claim.claim_input}"</p>
        <p className="claim-by">Claimed by: {claim.talker_name}, {claim.party}</p>
        
        <div className="claim-verdict">
          <span 
            className="verdict-pill" 
            style={{ backgroundColor: verdictColor }}
          >
            {claim.verdict}
          </span>
          <span className="verdict-sources">
            Verified against {claim.source_num} sources
          </span>
        </div>
        
        {/* Related bills toggle section */}
        {claim.related_bill && claim.related_bill.length > 0 && (
          <div className="related-bills-section">
            <button 
              className="toggle-related-bills"
              onClick={toggleRelatedBills}
            >
              {showRelatedBills ? 'Hide Related Bills' : 'Show Related Bills'}
            </button>
            
            {showRelatedBills && (
              <div className="related-bills-container">
                <ul className="related-bills-list">
                  {claim.related_bill.map((bill, index) => (
                    <li key={`bill-${index}`} className="related-bill">
                      {bill}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
        
        {/* View details button */}
        <div className="claim-actions">
          <button 
            className="view-details-btn" 
            onClick={handleViewDetails}
          >
            View Full Analysis
          </button>
        </div>
      </div>
    </div>
  );
};

// Same helper function for consistent colors
const getTopicColor = (topicName) => {
  const colors = {
    'Economy': '#08773c', // Australian green
    'Education': '#00843d',
    'Environment': '#006b3d',
    'Healthcare': '#008542',
    'Justice': '#f9cf00', // Australian gold
    'Social Services': '#f1b434',
    'Infrastructure': '#d5a021',
    'Foreign Affairs': '#ffcd00',
    // Default
    'default': '#08773c'
  };
  
  return colors[topicName] || colors.default;
};

export default TrendingClaimCard;